import { render, staticRenderFns } from "./FaceProfile.vue?vue&type=template&id=19b92ef3&scoped=true"
import script from "./FaceProfile.vue?vue&type=script&lang=js"
export * from "./FaceProfile.vue?vue&type=script&lang=js"
import style0 from "./FaceProfile.vue?vue&type=style&index=0&id=19b92ef3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b92ef3",
  null
  
)

export default component.exports